import { Address } from "../address";
import { ITL1_BY_CODE, ITLRegion } from "../geo/itl";

export interface IFA {
  name: string;
  abbrevName: string;
  registrationNumber: string;
  itl1Region: ITLRegion[];
  description: string;
  initialFeesDescription: string[];
  ongoingFeesDescription: string[];
  logo: string;
  logoClass: string;
  logoContainerStyle: string;
  hero: string;
  heroStyle: string;
  heroContainerStyle: string;
  heroFramed: boolean;
  contactName: string;
  contactEmail: string;
  website: string;
  phone?: string;
  address?: Address;
  isActive?: boolean;
}

export type IFAList = readonly IFA[];

export const IFAs: IFAList = [
    {
        name: "Inspo Wealth Management Limited",
        abbrevName: "Inspo",
        registrationNumber: "1016255",
        itl1Region: [ ITL1_BY_CODE["TLI"] ],
        description: "At Inspo Wealth Management, our clients are at the centre of everything we do. As whole-of-market, independent financial advisers, it is our responsibility to not only advise you on what you want, but also what you need.",
        initialFeesDescription: ["3% up to 100K", "2% 100K to 250K", "1% 250K to 500K", "0.5% above 500K"],
        ongoingFeesDescription: ["Under 200K 1%", "Over 200K 0.75%", "Over 500K 0.6%"],
        logo: "inspo-wealth-logo.jpg",
        logoClass: "",
        logoContainerStyle: "margin-top: -70px;",
        hero: "inspo-wealth-hero.webp",
        heroStyle: "object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Scott Miller",
        contactEmail: "scott@inspowealth.com",
        website: "https://inspowealth.com/"
    },
    {
        name: "GP Wealth",
        abbrevName: "GP Wealth",
        registrationNumber: "770143",
        itl1Region: [ ITL1_BY_CODE["TLJ"], ITL1_BY_CODE["TLH"] ],
        description: "At GP Wealth we focus on how to fit your financial plan around your objectives and needs. Our aim is to relieve the stresses of planning your financial future, making life simple. We look to build long-term relationships and understanding what your aims are and building a plan around those goals.",
        initialFeesDescription: ["Up to £500k - 1%", "£500k above - 0.5%", "Maximum initial fee = £15,000"],
        ongoingFeesDescription: ["Up to £500k - 1%", "£500k to £1m - 0.75%", "£1m+ - 0.5%", "Minimum ongoing fee of £1,000 per annum"],
        logo: "goddard-perry-wealth-logo.png",
        logoClass: "",
        logoContainerStyle: "margin-top: -90px;",
        hero: "goddard-perry-wealth-hero.webp",
        heroStyle: "object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Euan Buckland",
        contactEmail: "euan.buckland@gpwealth.co.uk",
        website: "https://www.gpwealth.co.uk/"
    },
    {
        name: "Aesir Wealth Ltd",
        abbrevName: "Aesir",
        registrationNumber: "764841",
        itl1Region: [ ITL1_BY_CODE["TLF"], ITL1_BY_CODE["TLG"] ],
        description: "With over 24 years' experience, Gavin Hill (Aesir Wealth) helps clients bring together pensions, investments, savings and other finances into one clear picture. By simplifying complex financial information and understanding client goals, he provides straightforward financial planning and guidance, helping clients make informed, prudent decisions with confidence and peace of mind.",
        initialFeesDescription: ["3% on first £150000", "2.75% on next £150,000"],
        ongoingFeesDescription: ["0.75% or 1.00%"],
        logo: "aesir-wealth-logo.jpg",
        logoClass: "",
        logoContainerStyle: "margin-top: -60px;",
        hero: "aesir-wealth-hero.webp",
        heroStyle: "object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Gavin Hill",
        contactEmail: "gavin.hill@aesirwealth.co.uk",
        website: "https://aesirwealth.co.uk/"
    },
    {
        name: "2plan Wealth Management Ltd, part of the Openwork Partnership",
        abbrevName: "2plan",
        registrationNumber: "461598",
        itl1Region: [ ITL1_BY_CODE["TLC"], ITL1_BY_CODE["TLE"] ],
        description: "We offer specialist, independent financial advice with a particular focus on retirement income planning, pension consolidation and estate planning. Led by Kieran Bradbury a Pension Transfer Specialist with over 20 years' experience, the practice serves high-net-worth individuals, business owners and retirees seeking bespoke, whole-of-market drawdown strategies. Clients benefit from rigorous, research-led advice, transparent fee structures and coordinated support across tax, legal and investment planning.",
        initialFeesDescription: ["1% - 3% of funds under advice (minimum fee may apply depending on case complexity). Fees are agreed and confirmed in writing before any advice is provided."],
        ongoingFeesDescription: ["1% per annum of funds under management. This covers regular reviews, ongoing suitability monitoring and access to the adviser."],
        logo: "2plan-logo.png",
        logoClass: "",
        logoContainerStyle: "margin-top: -110px;",
        hero: "2plan-hero.webp",
        heroStyle: "object-position: 25% 25%; object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Kieran Bradbury",
        contactEmail: "kieran.bradbury@2plan.com",
        website: "https://www.2plan.com/"
    },
    {
        name: "Life Plan Partners",
        abbrevName: "Life Plan Partners",
        registrationNumber: "1040605",
        itl1Region: [ ITL1_BY_CODE["TLC"], ITL1_BY_CODE["TLE"] ],
        description: "Life Plan Partners is a modern financial planning firm helping individuals and families make better financial decisions with confidence. Combining technology-enabled efficiency with personalised, Chartered financial advice, we support clients across investments, retirement planning, protection and wider financial planning. Whether you're looking to organise your finances, plan for the future or get a second opinion on your existing arrangements, our aim is to provide clear, straightforward advice tailored to your goals.",
        initialFeesDescription: ["1.00% implementation charge when client signs up with Life Plan Partners"],
        ongoingFeesDescription: ["0.85% ongoing advice fee"],
        logo: "life-plan-logo.webp",
        logoClass: "",
        logoContainerStyle: "margin-top: -75px;",
        hero: "life-plan-hero.webp",
        heroStyle: "object-position: right center; object-fit: contain; background-color: #091D57;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Will Lenehan",
        contactEmail: "wl@lifepp.co.uk",
        website: "https://www.lifeplanpartners.co.uk/"
    },
    {
        name: "Phil Anderson Financial Services",
        abbrevName: "Phil Anderson",
        registrationNumber: "631218",
        itl1Region: [ ITL1_BY_CODE["TLD"], ITL1_BY_CODE["TLE"] ],
        description: "Jake is an award-winning financial planner with Phil Anderson Financial Services, a leading independent firm. Recognised in the Financial Reporter 30 Under 30, he combines the resources of an established practice with a personal, approachable style to offer clear, unbiased advice tailored to your long-term goals.",
        initialFeesDescription: ["0 - 250k = 3%", "250 - 500k = 2%", "500k+ = 1%"],
        ongoingFeesDescription: ["0.75% per annum"],
        logo: "phil-anderson-logo.webp",
        logoClass: "",
        logoContainerStyle: "margin-top: -110px;",
        hero: "phil-anderson-hero.webp",
        heroStyle: "object-position: right center; object-fit: contain; background-color: #DBCFE0;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Jake Crossley",
        contactEmail: "jake@philandersonfinancial.co.uk",
        website: "https://www.philandersonfinancial.co.uk/"
    },
    {
        name: "Eadon & Co",
        abbrevName: "Eadon & Co",
        registrationNumber: "816029",
        itl1Region: [ ITL1_BY_CODE["TLD"] ],
        description: "William Burrows is a respected specialist in retirement income, annuities, and pension drawdown with over 25 years of experience. Co-founder of Eadon & Co and host of www.retirementprojectuk.co.uk, William combines unrivalled industry expertise with personal, focused service to guide clients clearly through their retirement options.",
        initialFeesDescription: ["Fixed fee £5,000-£7,500.", "2.5% first £100k", "1.5% next £200k", "1% next £100k"],
        ongoingFeesDescription: ["0.50%"],
        logo: "eadon-logo.png",
        logoClass: "p-4 bg-white",
        logoContainerStyle: "margin-top: -110px;",
        hero: "eadon-hero.jpg",
        heroStyle: "object-position: right center; background-color: black; object-fit: contain; filter: brightness(60%);",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "William Burrows",
        contactEmail: "billyb@williamburrows.com",
        website: "https://www.eadonco.com/"
    },
    {
        name: "Turkington Davis Limited",
        abbrevName: "Turkington Davis",
        registrationNumber: "1037691",
        itl1Region: [ ITL1_BY_CODE["TLN"] ],
        description: "Turkington Davis is an independent financial planning firm helping individuals, families, and business owners build and preserve wealth. Offering unbiased, whole-of-market advice across pensions, investments, and retirement planning, they create clear, personalized roadmaps to help clients achieve their long-term goals with total confidence.",
        initialFeesDescription: ["1%"],
        ongoingFeesDescription: ["0.9% on-going advice fee"],
        logo: "turkington-davis-logo.png",
        logoClass: "",
        logoContainerStyle: "margin-top: -110px;",
        hero: "turkington-davis-hero.webp",
        heroStyle: "object-position: 25% 15%;",
        heroContainerStyle: "background-color: #1A3A5F;",
        heroFramed: true,
        contactName: "Nicholas Turkington",
        contactEmail: " nick@turkingtondavis.co.uk",
        website: "https://www.turkingtondavis.co.uk/"
    },
    {
        name: "Lucid Financial Planning",
        abbrevName: "Lucid",
        registrationNumber: "1051399",
        itl1Region: [ ITL1_BY_CODE["TLM"] ],
        description: "Lucid Financial Planning helps people make confident decisions about their future - not just their money. We go beyond pensions and investments, focusing on how you want to live your life and building a plan to support it. Using clear, evidence-based strategies and ongoing behavioural coaching, we help clients stay on track through uncertainty. The aim is simple: to give you clarity, control, and reassurance - so you can answer the question “am I going to be ok?” with confidence.",
        initialFeesDescription: ["3% on first £100k", "2.25% from £100,001 to £250k", "1.5% from £250,001 to £500k", "1% above £500k"],
        ongoingFeesDescription: ["1% of AUM"],
        logo: "lucid-financial-planning-logo.webp",
        logoClass: "",
        logoContainerStyle: "margin-top: -78px;",
        hero: "lucid-financial-planning-hero.webp",
        heroStyle: "object-position: 25% 15%; object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Craig McLaren",
        contactEmail: "craig@lucidfinancialplanning.co.uk",
        website: "https://www.lucidfinancialplanning.co.uk/"
    },
    {
        name: "MFP Wealth Management",
        abbrevName: "MFP",
        registrationNumber: "505247",
        itl1Region: [ ITL1_BY_CODE["TLK"] ],
        description: "MFP Wealth Management provides independent retirement planning advice to help clients gain clarity on when they can retire, how to structure pensions and investments tax-efficiently, and how to create sustainable income throughout retirement. Founded and led by Justin King, a Chartered Financial Planner and Certified Financial Planner, we focus on clear, jargon-free guidance and robust planning, supported by an academically-grounded investment approach.",
        initialFeesDescription: [
            "Initial consultation: no charge.",
            "Planning stage (Getting to know you / analysis & plan): usually minimum £2,500 depending on complexity, payable by invoice or deducted from investments.",
            "Implementation/restructuring of investments/pensions: up to 3% of the amount involved (complexity-dependent)."
        ],
        ongoingFeesDescription: [
            "Ongoing wealth management/financial planning fee (tiered, % of investment value):",
            "£0 - £1,000,000: 1.00%",
            "£1,000,000.01 - £3,000,000: 0.75%",
            "£3,000,000.01 - £5,000,000: 0.50%",
            "£5,000,000.01 - £10,000,000: 0.25%",
            "£10,000,000.01+: 0.20%"],
        logo: "mfp-wealth-management-logo.png",
        logoClass: "px-4 py-3",
        logoContainerStyle: "margin-top: -45px;",
        hero: "mfp-wealth-management-hero.png",
        heroStyle: "object-position: right center; object-fit: contain; background-color: #1D2D48;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Justin King",
        contactEmail: "jk@mfpwealthmanagement.co.uk",
        website: "https://www.mfpwealthmanagement.co.uk/"
    },
    {
        name: "Tony Thomas Wealth Management Ltd",
        abbrevName: "Tony Thomas",
        registrationNumber: "483403 (Hexagon Wealth Limited)",
        itl1Region: [ ITL1_BY_CODE["TLL"] ],
        description: "Tony Thomas is a Chartered Financial Adviser and Managing Director of TT Wealth Ltd, among the first in the UK to achieve the prestigious Chartered status in 2005. Drawing from his own experience of growing up in financial hardship, he has dedicated over 35 years to helping clients achieve security, clarity, and peace of mind for their future.",
        initialFeesDescription: ["1-3% of FUM"],
        ongoingFeesDescription: ["0.75% - 1.00%"],
        logo: "tony-thomas-wealth-logo.webp",
        logoClass: "",
        logoContainerStyle: "margin-top: -100px; width: 120px;",
        hero: "tony-thomas-wealth-hero.jpg",
        heroStyle: "object-position: 25% 38%; object-fit: cover;",
        heroContainerStyle: "",
        heroFramed: false,
        contactName: "Tony Thomas",
        contactEmail: "tony@ttwealth.co.uk",
        website: "https://ttwealth.co.uk/"
    }
];
